module.exports = __webpack_public_path__ + "static/media/backbutton.57e4d9d8.png";